import { EInvoiceProfile } from '@scrubtech/models'
import { createModelStore, ModelStateKey } from '@scrubtech/redux-model-factory'
import {
  getEInvoiceProfiles,
  getEInvoiceProfile,
  createEInvoiceProfile,
  updateEInvoiceProfile,
  deleteEInvoiceProfile,
} from '../../api/eInvoiceProfiles'

// Create the store module
const storeModule = createModelStore<EInvoiceProfile>({
  actionTypePrefix: 'E_INVOICE_PROFILES',
  getEntityID:      profile => profile.id,
  stateKey:         'eInvoiceProfiles' as ModelStateKey<EInvoiceProfile>,
  entityName:       'E-Invoice Profile',
  service:          {
    fetchAll:  async (params) => {
      return await getEInvoiceProfiles(params.sorting, params.page, params.limit, params.search)
    },
    fetchByID: async (id: number) => {
      return await getEInvoiceProfile(id)
    },
    create:    async (data) => {
      const createData = {
        ...data,
        sstNumber:    data.sstNumber || '',
        addressLine2: data.addressLine2 || '',
        addressLine3: data.addressLine3 || '',
      }
      return await createEInvoiceProfile(createData)
    },
    update:    async (id, data) => {
      const updateData = {
        ...data,
        sstNumber:    data.sstNumber || '',
        addressLine2: data.addressLine2 || '',
        addressLine3: data.addressLine3 || '',
      }
      return await updateEInvoiceProfile(id, updateData)
    },
    delete:    async (id) => {
      return await deleteEInvoiceProfile(id)
    },
  },
  navigationConfig: {
    getPostCreationUrl: (profile) => `/e-invoice-profiles/${profile.id}`,
    getPostDeletionUrl: () => '/e-invoice-profiles',
  },
})

// Extract and export the reducer, actions, and selectors
const {
        reducer,
        actions,
        selectors,
        actionTypes,
      } = storeModule

// Export everything
export {
  // Actions
  actions as eInvoiceProfilesActions,

  // Selectors
  selectors as eInvoiceProfilesSelectors,

  // Action Types
  actionTypes as eInvoiceProfilesActionTypes,

  // Reducer
  reducer as eInvoiceProfilesReducer,
}

// Export types
export type { EInvoiceProfile }

// Export query creator
export const createProfileQuery = (page: number = 1, limit: number = 10, search: string = '') => ({
  page,
  limit,
  search,
})
